module.exports = __webpack_public_path__ + "img/feedback_hover.5081c4d3.svg";